import styled from 'styled-components';

export const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
`;
